import { VisibilityType } from "@apiserver-rest/ponder-data-client-base";

export const VisibilityTypes = new Map<VisibilityType, string>([
    [ VisibilityType.Public, "Public" ],
    [ VisibilityType.Friends, "Friends Only" ],
    [ VisibilityType.Private, "Private" ]
]);

export const VisibilityTypesReversed = new Map<VisibilityType, string>([
    [ VisibilityType.Private, "Private" ],
    [ VisibilityType.Friends, "Friends Only" ],
    [ VisibilityType.Public, "Public" ]
]);